// extracted by mini-css-extract-plugin
export var center = "_10-2";
export var clickableRow = "_10-5";
export var expandedRow = "_10-7";
export var hoverable = "_10-4";
export var left = "_10-1";
export var right = "_10-3";
export var row = "_10-0";
export var selectedRow = "_10-6";
export var summaryRow = "_10-8";